import useSlingApi from '@sdk/api/useSlingApi';
import useToast from '@sdk/common/toast/useToast';
import { extendBillingInfo } from '@sdk/account/utils';
import getErrorForToast from '@sdk/api/utils/getErrorForToast';

import { useBillingInfo } from '@web/account/billing/BillingInfoContext';

export const useDowngradeOfferModal = (accept, reasonId, reasonText) => {
  const { onBillingInfoUpdated } = useBillingInfo();
  const { showErrorToast } = useToast();
  const api = useSlingApi();

  const acceptDowngradeOffer = async () => {
    try {
      const { data } = await api.account.downgradeSubscription({ reasonId, reasonText });
      onBillingInfoUpdated(extendBillingInfo(data));
      accept();
    } catch (e) {
      showErrorToast(getErrorForToast(e));
      throw e;
    }
  };

  return {
    acceptDowngradeOffer,
  };
};
